export const path = fragmentIdentifier => {
  const {baseURI} = document;
  const {href, hash} = window.location;
  return `${href.replace(baseURI, '').replace(hash, '')}${fragmentIdentifier}`;
};
